/**
 * IK Online - Aboservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AboDocumentSourceExportType = 'PDF' | 'XLSX' | 'CSV' | 'FUNDSXML' | 'FUNDSXML4' | 'ZIABRIS';

export const AboDocumentSourceExportType = {
    Pdf: 'PDF' as AboDocumentSourceExportType,
    Xlsx: 'XLSX' as AboDocumentSourceExportType,
    Csv: 'CSV' as AboDocumentSourceExportType,
    Fundsxml: 'FUNDSXML' as AboDocumentSourceExportType,
    Fundsxml4: 'FUNDSXML4' as AboDocumentSourceExportType,
    Ziabris: 'ZIABRIS' as AboDocumentSourceExportType
};

